import { Icon } from '@octano/global-ui';

const CreatedAt = ({ date }: { date: string | null }) => {
  return (
    <p
      className="d-flex align-items-center justify-content-start m-0"
      style={{ gap: '8px' }}
    >
      <Icon name="calendar" color="primary" size="16px" />
      {date}
    </p>
  );
};

export default CreatedAt;
